import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import CountryFlag from 'vue-country-flag'
import { Amplify } from 'aws-amplify'
import awsExports from './aws-exports'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import JsonCSV from 'vue-json-csv'
import router from './router'
import store from './store'
import { setup } from './views/middleware'
import '@/plugins/apexcharts'
import '@aws-amplify/ui-vue'

Amplify.configure(awsExports)
Vue.use(Vuex)
Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT_API
router.beforeEach(setup)
Vue.component('country-flag', CountryFlag)
Vue.component('downloadCsv', JsonCSV)

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App)
}).$mount('#app')
